import DatePicker from "react-datepicker";
import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import InputMask from "react-input-mask";
import { toast, ToastContainer } from "react-toastify";
import { validateDate } from "../utils/GeneralUtils";

const PastDatePicker = (props: any) => {
  const {
    input,
    meta: { touched, error },
    valuedata,
  } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isOpen, setIsOpen] = useState(true);
  const [dateValue, setdateValue] = useState<any>("");

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const addDays = (days: number): Date => {
    const futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + days);
    return futureDate;
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const disableWeekends = (date: Date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  };
  const handleChangeRaw = (value: any) => {
    setdateValue(value);
    if (validateDate(value)) {
      const date = moment(value);
      if (moment(value).isBefore() && value.slice(0, 2) === date.format("MM")) {
        props.input.onChange(date);
      } else {
        toast.error("Enter valid date");
      }
    } else {
      props.input.onChange("");
      if (
        value !== undefined &&
        value !== "__/__/____" &&
        value !== "" &&
        !value.includes("_") &&
        dateValue !== value
      ) {
        toast.error("Enter valid date(MM/DD/YYYY)");
      }
    }
  };
  return (
    <>
      <DatePicker
        onSelect={(date: any) => {
          const selectedDate = moment(date).format("L");
          input.onChange(selectedDate);
        }}
        dateFormat="MM/dd/yyyy"
        selected={input?.value ? new Date(input?.value) : undefined}
        disabledKeyboardNavigation
        {...props}
        shouldCloseOnSelect={true}
        onClickOutside={() => setIsOpen(true)}
        onInputClick={() => setIsOpen(true)}
        startDate={input.startDate}
        onChangeRaw={(event) => handleChangeRaw(event.target.value)}
        customInput={
          <InputMask mask="99/99/9999" placeholder="Enter birthdate" />
        }
      />
      <h6 className="danger">
        {valuedata === null && touched && error && <span>{error}</span>}
      </h6>
      {/* <ToastContainer/> */}
    </>
  );
};

export default PastDatePicker;
